import { HttpInterceptorFn } from '@angular/common/http';

export const acceptInterceptor: HttpInterceptorFn = (req, next) => {
  return next(
    req.clone({
      setHeaders: {
        Accept: 'application/vnd.pardos.v1+json',
      },
    }),
  );
};
